import {
  loginErr,
  loginStart,
  loginSuccess,
  signupErr,
  signUpStart,
  signUpSuccess,
} from "../REDUX/Registration/Registration";
import { PublicRequest } from "../RequestMethod";
import { showToast } from "../utils/Toastify";
import { getUser } from "./CheckTokenAndGEtUser";

/* This function save the user token to localstorage when called */
function saveTokenToStorage(token) {
  localStorage.setItem("TimeShoppy", token);
}
// const token = localStorage.getItem("TimeShoppy");

/*Register user  */
export const SignupApi = async (dispatch, user) => {
  dispatch(signUpStart());
  try {
    const res = await PublicRequest.post("auth/signup", user);

    /* dispatch the signUpSucces */
    dispatch(signUpSuccess(res.data));
    /* call the function that save the user token to locastorage */
    saveTokenToStorage(res.data.token);
    /* call the function that check token and get the user Info */
    showToast("Sign up Success🥰!", "success");
    await getUser(dispatch);
  } catch (error) {
    console.log(error);
    dispatch(signupErr(error.response.data));
  }
};
/*Login user  */
export const LoginApi = async (dispatch, user) => {
  // console.log(user, "hii");
  // return;
  dispatch(loginStart());
  try {
    /* call the function that save the user token to locastorage */
    const res = await PublicRequest.post("auth/login", user);
    console.log(res, "res");
    /* dispatch the signUpSucces */
    dispatch(loginSuccess(res.data));
    saveTokenToStorage(res.data.token);
    /* call the function that check token and get the user Info */
    showToast("Login Success!", "success");
    await getUser(dispatch);
  } catch (error) {
    console.log(error, "from mee");
    dispatch(loginErr(error.response.data));
    if (error.code === "ERR_NETWORK") {
      // alert("network err");
      showToast("network err!", "error");
    }
  }
};
